import React from "react";
import "./FloatingActions.css";
import { FaPhoneAlt, FaWhatsapp, FaCalendarCheck, FaMapMarkerAlt } from "react-icons/fa";

const FloatingActions = () => {
  return (
    <div className="floating-actions">

      {/* Call */}
      <a
        href="tel:+919087775659"
        className="action-btn call"
        title="Call Us"
        aria-label="Call Us"
      >
        <FaPhoneAlt />
      </a>

      {/* WhatsApp */}
      <a
        href="https://wa.me/919087775659"
        target="_blank"
        rel="noopener noreferrer"
        className="action-btn whatsapp"
        title="WhatsApp"
        aria-label="WhatsApp"
      >
        <FaWhatsapp />
      </a>

      {/* Book Appointment */}
      <a
        href="/"
        className="action-btn book"
        title="Book Now"
        aria-label="Book Now"
      >
        <FaCalendarCheck />
      </a>

      {/* Location / Map */}
      <a
        href="https://maps.app.goo.gl/FHrCNX5dKfNtu65n6?g_st=aw"
        target="_blank"
        rel="noopener noreferrer"
        className="action-btn location"
        title="Find Location"
        aria-label="Find Location"
      >
        <FaMapMarkerAlt />
      </a>

    </div>
  );
};

export default FloatingActions;